import { render, staticRenderFns } from "./ActivateUser.vue?vue&type=template&id=1fbc09de&"
import script from "./ActivateUser.vue?vue&type=script&lang=js&"
export * from "./ActivateUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports